const withGeneralFiles = files => prevProjectOrTemplate => ({
    ...prevProjectOrTemplate,
    files,
});

export default withGeneralFiles;
